{
  "name": "fzf-webapp",
  "version": "2.143.0",
  "license": "MIT",
  "files": [
    "dist/*"
  ],
  "scripts": {
    "postinstall": "node ./scripts/update-docker-package-json.js && node scripts/grab-git-info.js",
    "ng": "ng",
    "start": "ng serve",
    "start-en": "ng serve --configuration=development-en",
    "start-fr": "ng serve --configuration=development-fr",
    "start-it": "ng serve --configuration=development-it",
    "lint": "ng lint",
    "format": "prettier \"**/*.*\" --write",
    "build:ng": "ng run fzf-webapp:ngsscbuild:production",
    "build:server": "rollup -c rollup.config.js",
    "build": "npm-run-all -l build:ng build:server",
    "postbuild": "node scripts/postbuild.js",
    "test": "ng test --karma-config ./src/karma.conf.js --watch=false --source-map=false",
    "openapi:generate-local-v3": "openapi-generator-cli generate -g typescript-angular -i api-docs-v3.37.1.json --type-mappings=set=Array -o ./src/app/client/js-openapi3-client-v3",
    "extract-i18n": "ng extract-i18n --out-file translations.xlf",
    "t9n": "ng run fzf-webapp:t9n"
  },
  "dependencies": {
    "@instana/collector": "^2.21.0",
    "@openapitools/openapi-generator-cli": "^2.41.0",
    "@sbb-esta/angular": "^22.1.0",
    "@types/node": "^26.5.1",
    "angular-server-side-configuration": "^11.0.2",
    "axios": "^1.15.0",
    "client-oauth2": "^4.3.3",
    "git-describe": "^4.1.1",
    "koa": "^2.16.4",
    "koa-body": "^6.0.1",
    "koa-logger": "^3.2.1",
    "koa-static": "~5.0.0",
    "node-fetch": "^2.6.1",
    "zod": "^3.24.2"
  },
  "optionalDependencies": {
    "puppeteer": "^22.4.1"
  },
  "devDependencies": {
    "@angular-devkit/core": "^22.1.8",
    "@angular-eslint/builder": "^22.5.0",
    "@angular-eslint/eslint-plugin": "^22.5.0",
    "@angular-eslint/eslint-plugin-template": "^22.5.0",
    "@angular-eslint/schematics": "^22.5.0",
    "@angular-eslint/template-parser": "^22.5.0",
    "@angular/animations": "^22.1.6",
    "@angular/build": "^22.1.8",
    "@angular/cdk": "^22.1.6",
    "@angular/cli": "22.1.8",
    "@angular/common": "^22.1.6",
    "@angular/compiler": "^22.1.6",
    "@angular/compiler-cli": "^22.1.6",
    "@angular/core": "^22.1.6",
    "@angular/forms": "^22.1.6",
    "@angular/language-service": "^22.1.6",
    "@angular/localize": "^22.1.6",
    "@angular/platform-browser": "^22.1.6",
    "@angular/platform-browser-dynamic": "^22.1.6",
    "@angular/router": "^22.1.6",
    "@gfx/zopfli": "^1.0.14",
    "@types/arcgis-js-api": "^4.14.0",
    "@types/file-saver": "^2.0.1",
    "@types/geojson": "^7946.0.10",
    "@types/jasmine": "^4.3.5",
    "@types/koa": "^2.11.0",
    "@types/koa-logger": "^3.1.1",
    "@types/koa-static": "^4.0.1",
    "@types/mapbox-gl": "^2.7.13",
    "@types/node-fetch": "^2.5.7",
    "@types/request-promise-native": "^1.0.17",
    "@typescript-eslint/eslint-plugin": "^8.70.0",
    "@typescript-eslint/parser": "^8.70.0",
    "acorn": "^8.8.2",
    "angular-t9n": "^16.0.0",
    "codelyzer": "^6.0.0",
    "core-js": "^3.30.1",
    "date-fns": "^2.30.0",
    "eslint": "^9.28.0",
    "esri-loader": "^3.7.0",
    "file-saver": "^2.0.2",
    "istanbul-lib-instrument": "^6.0.3",
    "jasmine-core": "^5.1.1",
    "jasmine-spec-reporter": "~7.0.0",
    "karma": "^6.4.2",
    "karma-chrome-launcher": "^3.2.0",
    "karma-jasmine": "^5.1.0",
    "karma-jasmine-html-reporter": "^2.0.0",
    "ncp": "^2.0.0",
    "ngx-spec": "^2.1.6",
    "npm-run-all": "^4.1.5",
    "nswag": "^13.20.0",
    "prettier": "^2.8.8",
    "rollup": "^4.63.1",
    "rollup-plugin-typescript2": "^0.35.0",
    "rxjs": "^7.8.1",
    "ts-node": "^10.9.1",
    "tslib": "^2.4.1",
    "typescript": "^6.0.3",
    "zone.js": "~0.15.0"
  },
  "prettier": {
    "singleQuote": true,
    "endOfLine": "lf",
    "printWidth": 100
  }
}
